<template>
<div ui-view="" class="app-body" id="view">
  <component v-bind:is="component"></component>
</div>
</template>

<script>
//import UserDetail from './UserDetail.vue'
import UserEdit from './user/UserEdit.vue'
import UserList from './user/UserList.vue'

export default {
  components: { UserList},
  data() {
    return {
      component: null
    }
  },
  mounted(){
    this.init();
  },
  watch:{
    $route(to) { 
      this.init();
    }
  },
  methods: {
    init(){
      

      /*
      if(this.$route.query.mode== 'view'){
        this.component = UserDetail
        return;
      }
      */
      if(this.$route.query.mode== 'new'){
        this.component = UserEdit
        return;
      }
      
      if(typeof this.$route.query.mode == "undefined" || this.$route.query.mode == 'list' || this.$route.query.mode == ''){
        this.component = UserList
        return;
      }      
    }
  },
}
</script>

<style>

</style>